var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12ZM12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12H0L4 16L8 12H5C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19.0014 13.2858 18.6483 14.5471 17.9796 15.6453C17.3109 16.7435 16.3524 17.6362 15.2095 18.2252C14.0666 18.8142 12.7834 19.0769 11.5009 18.9842C10.2185 18.8916 8.98639 18.4472 7.94 17.7L6.52 19.14C7.65464 20.0107 8.98046 20.5985 10.3876 20.8545C11.7947 21.1106 13.2426 21.0277 14.6112 20.6126C15.9799 20.1975 17.2299 19.4622 18.2577 18.4676C19.2855 17.473 20.0614 16.2478 20.5213 14.8935C20.9811 13.5392 21.1115 12.0949 20.9018 10.6801C20.692 9.26534 20.1481 7.92094 19.3151 6.75832C18.4822 5.59569 17.3841 4.64833 16.112 3.99474C14.8398 3.34114 13.4302 3.00015 12 3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.85c312eec5e8b172137f99e08b9c13cd.svg";
export { ForwardRef as ReactComponent };